import BaseDiagramModel from "../models/BaseDiagramModel";
import NodeRegistry from "./NodeRegistry";
export default class AppValidation {
    static usedInArray() {
        const usedIn = {
            'global_intent_mapping': [],
            'dtmf_nodes': [],
            'module':[],
            'input': [],
            'functions': [],
            'custom_script': [],
            'modules': [],
            'module_exit': [],
            'module_reference': [],
            'data_access_completion': [],
            'data_access': [],
            'prompt_reference': [],
            'prompt': [],
            'module': [],
            'save_prompt': [],
            'play_save_prompt': [],
            'report_node': [],
            'tab_node': [],
            'global_intent_pre_processing_module': [],
            'user_ended_session_module': [],
            'session_start_module': [],
            'returning_from_wait_module': [],
            'process_engine_exception_or_error': [],
            'timeout_handler': [], 'compound_intents': []
        };
        return usedIn;
    }
    static applicationValidation(serialized) {
        
        const {components, globalIntents, compoundIntents} = serialized;
        const errors = {
            intents: [],
            moduleCircularDependencies: [],
            modules: [],
            variables: [],
            dtmfNodes: [],
            inputNodes: [],
            customNodes: [],
            moduleExits: [],
            moduleReferenceNodes: [],
            dataAccessCompletionNodes: [],
            dataNodes: [],
            promptReferenceNodes: [],
            promptNodes: [],
            savedPromptNodes: [],
            playSavedPromptNodes: [],
            reportingNodes: [],
            tabularRouterNodes: [],
            globalIntents: [],
            unUsedModules: [],
            compoundIntents: [],
            ccxml: "",

        };
        //ccxml validation
        if (serialized.ccxml === "") {
            errors.ccxml = "CCXML cannot be empty";
        }
        
        //module validation
        for (var m = 0, len = components.modules.length ; m < len; m++) {
            const module = components.modules[m];
            const results = AppValidation.checkModule(module);
            if (results && results.errorCount) {
                errors.modules.push({ modules: module, results: results });
            }
        }

        // See DEVDES2-949 Prevent Circular Module Dependencies when adding Module to canvas
        // errors.modules.forEach(m => {
        //     m.results.circularDependencies.forEach(cd => {
        //         errors.moduleCircularDependencies.push({ module: m.modules, error: cd.error});
        //     });
        // });

        //globalIntent Validation
        globalIntents.forEach(gi => {
            const module = window.apm.getNode(gi.module);
            const globalIntent = {
                id: gi.id,
                name: "",
                message:"Global Mapping shouldn't be empty",
                props: {
                    "iconClass": "compass"
                }

            };
            if (gi.intent!==undefined) {
                const intent = window.apm.getNode(gi.intent);
                if (intent === null && module === null) {
                    globalIntent.name = "Empty GlobalIntent";
                    errors.globalIntents.push({ globalIntents: globalIntent});
                }
                else if (intent === null) {
                    globalIntent.name = module.name;
                    globalIntent.message = "No Intent Mapped";
                    globalIntent.props.iconClass = "package";
                    errors.globalIntents.push({ globalIntents:globalIntent });
                }
                else if (module === null) {
                    globalIntent.name = intent.name;
                    globalIntent.message = "No Module Mapped";
                    globalIntent.props.iconClass = "radio";
                    errors.globalIntents.push({ globalIntents: globalIntent });
                }
            }
            else if (gi.condition!==undefined) {
                if (module && gi.conditionProperties.props.config.name === "") {
                    globalIntent.name = module.name;
                    globalIntent.message = "Condition name is empty";
                    globalIntent.props.iconClass = "package";
                    errors.globalIntents.push({ globalIntents: globalIntent });
                }
                else if (!module && gi.conditionProperties.props.config.name!=="") {
                    globalIntent.name = gi.conditionProperties.props.config.name;
                    globalIntent.props.iconClass = "link";
                    globalIntent.message = "No Module Mapped";
                    errors.globalIntents.push({ globalIntents: globalIntent });
                }
                else if (!module && !gi.conditionProperties.props.config.name) {
                    globalIntent.name = "Empty GlobalIntent";
                    errors.globalIntents.push({ globalIntents: globalIntent });
                }
            }
           
            
            

        });
        
        //compoundIntents
        compoundIntents.forEach(comInt => {


            var intent = {
                fromIntent1: window.apm.getNode(comInt.fromIntent1),
                fromIntent2: window.apm.getNode(comInt.fromIntent2),
                toIntent: window.apm.getNode(comInt.toIntent)
            };
            if (intent.fromIntent1 === null || intent.fromIntent2 === null || intent.toIntent === null) {
                errors.compoundIntents.push({ compoundIntents: intent });
            }
        });
        
        return errors;

    }
    static checkModule(module) {
        if (!window.apm.hasPermission(module.id, "read")) {
            return null;
        }
        const diagramModel = new BaseDiagramModel(module.id);
        if (module.versions[module.version].flow) {
            diagramModel.suppressBroadcast = true;
            for (var i = 0, len = module.versions[module.version].flow.nodes.length; i < len; i++) {
                const element = module.versions[module.version].flow.nodes[i];
                try {
                    //const newNode = new NodeRegistry.r[element._class](element.name, element.x, element.y, element.props, element.id);
                    const newNode = NodeRegistry.buildNode(element);
                    diagramModel.addNode(newNode, {graphModel: diagramModel, isValidation: true});
                } catch (e) {
                    const directMessage = element.name + ' has undefined class named: ' + element._class;
                    const errors = {
                        errorCount: 1,
                        directMessage: directMessage,
                        beginNode: [],
                        links: [],
                        nodes: [],
                        unusedLinks: [],
                        unusedNodes: [],
                        unusedLocalVariables: []
                    };
                    errors.nodes.push({ elem: element, error: directMessage });
                    return errors;
                }
            }
            for (var i = 0, len = module.versions[module.version].flow.links.length; i < len; i++) {
                const element = module.versions[module.version].flow.links[i];
                if (element.source && element.target) {
                    try {
                        const sourcePort = (diagramModel.getNode(element.source).getPorts())[element.sourcePort];
                        const targetPort = (diagramModel.getNode(element.target).getPorts())[element.targetPort];
                        const newLink = new NodeRegistry.r[element._class](sourcePort, targetPort, element.props, element.id);
                        diagramModel.addLink(newLink);
                    }
                    catch (e) {
                        // TODO: hot-fix DEVDES2-703
                        console.log(e);
                    }
                }
            }
        }
        return diagramModel.validateDiagram();
    }

}